import { resolveUseCase, type Card, type UseCasesFile } from '../../lib/cards';

/**
 * 画面に渡すカード。useCase を card-schema.md §2.3 の順（カード → 教科書の章 → unit）で解決して埋める。
 * CardShell は card.useCase を読むので、解決済みの値を持たせたコピーを渡す。
 */
export function withResolvedUseCase(card: Card, useCases: UseCasesFile | null): Card {
  const useCase = resolveUseCase(card, useCases);
  if (useCase === null) {
    if (card.useCase === undefined) return card;
    const copy = { ...card };
    delete copy.useCase;
    return copy;
  }
  return useCase === card.useCase ? card : { ...card, useCase };
}

/**
 * useCase を出すか（card-schema.md §2.3）。新しいカードの最初の 1 回だけ出す（復習・入れ直しでは出さない）。
 * reduce は例外で、回答後に出す（正解の手法の useCase なので、先に出すと答えが分かる）。
 */
export function shouldShowUseCase(
  card: Pick<Card, 'type'>,
  entry: { fresh: boolean; retry: boolean; answered: boolean },
): boolean {
  if (card.type === 'reduce') return entry.answered;
  return entry.fresh && !entry.retry;
}
